function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "b8f4b1ce-0d4f-40ef-90c3-daa5525a1ce4",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.89,8.52H10.11a4,4,0,0,0-4,4V38.75a4,4,0,0,0,4,4h15l-1.31,7.16H22v1.59H38V49.89H36.23l-1.3-7.16h15a4,4,0,0,0,4-4V12.5A4,4,0,0,0,49.89,8.52Zm-42.17,4a2.39,2.39,0,0,1,2.39-2.39H49.89a2.39,2.39,0,0,1,2.39,2.39V35.57H7.72ZM34.61,49.89H25.39l1.3-7.16h6.63ZM52.28,38.75a2.39,2.39,0,0,1-2.39,2.39H10.11a2.39,2.39,0,0,1-2.39-2.39V37.16H52.28Z"
}));

var SvgSettingsComputer = function SvgSettingsComputer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsComputer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings_computer.c07c09a5.svg";
export { ForwardRef as ReactComponent };